import { PageHeader } from "@repo/ui/Navigation/pageHeader";
import { PageWidth } from "@repo/ui/Navigation/pageWidth";
import type { FC, ReactNode } from "react";
import { PageBody, PageLayout } from "../../../components/layout/pageLayout.js";

export interface SettingsSectionProps {
  children: ReactNode;
}

export const SettingsSection: FC<SettingsSectionProps> = (props) => (
  <PageBody width={PageWidth.Form}>
    <div className="flex flex-1 flex-col">{props.children}</div>
  </PageBody>
);

export interface SettingsSectionPageProps {
  title: ReactNode;
  /** Right-aligned header controls, passed through to `PageHeader`. */
  actions?: ReactNode;
  children: ReactNode;
}

/**
 * The standard flowing settings page: a `PageHeader` at the settings
 * readability width above a single `SettingsSection`. Sections with tabs or
 * bounded full-height layouts compose the shell primitives directly instead.
 */
export const SettingsSectionPage: FC<SettingsSectionPageProps> = (props) => (
  <PageLayout>
    <PageHeader
      width={PageWidth.Form}
      title={props.title}
      actions={props.actions}
    />
    <SettingsSection>{props.children}</SettingsSection>
  </PageLayout>
);
